import axios from './../../libs/api.request'

export function add (data) {
  return axios.request({
    url: '/customer/group/add',
    method: 'post',
    data
  })
}

export function update (data) {
  return axios.request({
    url: '/customer/group/update',
    method: 'post',
    data
  })
}

export function queryGroup (data) {
  return axios.request({
    url: '/customer/group/list',
    method: 'post',
    data
  })
}

export function queryCustomerFromGroup (data) {
  return axios.request({
    url: '/customer/group/customers',
    method: 'post',
    data
  })
}

export function addUserToGroup (data) {
  return axios.request({
    url: '/customer/group/member/join',
    method: 'post',
    data
  })
}

export function removeUserToGroup (data) {
  return axios.request({
    url: '/customer/group/member/remove',
    method: 'post',
    data
  })
}

export function operationByPath (path) {
  return axios.request({
    url: path,
    method: 'get'
  })
}

export function deleteByIds (data) {
  return axios.request({
    url: '/customer/group/deleteByIds',
    method: 'post',
    data
  })
}

export function queryGroupMembers (data) {
  return axios.request({
    url: '/customer/group/member/list',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/components/customerGroup/groupApi.js